import {
  LOGIN_PROFILE_CREATED_RESET,
  REQUEST_TABLE_DATA,
  REQUEST_TABLE_DATA_FAILURE,
  REQUEST_TABLE_DATA_SUCCESS,
} from "../../utils/constants";

export const handleTableDataRequest = (state) => ({
  ...state,
  error: null,
  isLoading: true,
  redirect: false,
});

export const handleTableDataRequestSuccess = (state, action) => {
  const response = action?.payload?.data;
  if (response?.status >= 200 && response?.status < 300) {
    return {
      ...state,
      data: response.data,
      error: null,
      isLoading: false,
      redirect: false,
    };
  }

  return { ...state, error: "Unable to load leads.", isLoading: false };
};

export const handleTableDataRequestFailure = (state, action) => {
  const response = action?.payload?.response;
  const token = localStorage.getItem("access_token");
  const error =
    response?.data?.detail ||
    response?.data?.message ||
    action?.payload?.message ||
    "Unable to load leads.";

  if (!token) {
    return { ...state, data: null, error: null, isLoading: false, redirect: true };
  }

  return { ...state, data: null, error, isLoading: false, redirect: false };
};

const initialState = {
  data: undefined,
  error: null,
  isLoading: false,
  redirect: false,
};

const handlers = {
  [LOGIN_PROFILE_CREATED_RESET]: () => initialState,
  [REQUEST_TABLE_DATA]: handleTableDataRequest,
  [REQUEST_TABLE_DATA_SUCCESS]: handleTableDataRequestSuccess,
  [REQUEST_TABLE_DATA_FAILURE]: handleTableDataRequestFailure,
};

export default function tableReducer(state = initialState, action) {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
}
